import { Route, Routes } from "react-router-dom"
import useUserActivityTracker from "../hooks/useUserActivityTracker"
import ProtectedRoutes from "./ProtectedRoute"
import AuthenticationRoutes from "./AuthenticationRoute"
import { AUTHENTICATED_ROUTES, GLOBAL_ROUTES, UNAUTHENTICATED_ROUTES } from "./routes.data"

const MainRoutes = () => {
  // Hook to track user-activity
  useUserActivityTracker()

  return (
    <Routes>
      {/* --- Not Authenticated/ User not SignedIn --- */}
      <Route element={<AuthenticationRoutes />}>
        {UNAUTHENTICATED_ROUTES?.map((route, key) => <Route key={key} path={route.path} element={route.element} />)}
      </Route>

      {/* --- Authenticated/ User SignedIn --- */}
      <Route element={<ProtectedRoutes />}>
        {AUTHENTICATED_ROUTES?.map((route, key) => <Route key={key} path={route.path} element={route.element} />)}
      </Route>

      {/* --- Other/ Globaly Available --- */}
      {GLOBAL_ROUTES?.map((route, key) => <Route key={key} path={route.path} element={route.element} />)}
    </Routes>
  )
}

export default MainRoutes